import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faGlobe, faCity, faList, faUserGroup, faDoorOpen, faCircleQuestion, faPenToSquare, faHouse, faBoxArchive } from '@fortawesome/free-solid-svg-icons';
import './SidebarMenu.css';
import { get } from '../../utils/api';

// Вспомогательный компонент для отображения пункта меню
const SidebarLink = ({ to, cmp, icon, text}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const match = location.pathname.startsWith(cmp);
  
    return (
        <div
            className={match ? 'SidebarLink SidebarLink-active' : 'SidebarLink SidebarLink-simple'}
            onClick={() => navigate(to)}
        >
            <span className='icon'>
                <Icon icon={icon} fixedWidth/>
            </span>
            <span className='text'>
                {text}
            </span>
        </div>
    );
};


const SidebarMenu = () => {
    const { t } = useTranslation();
    const user = useSelector(state => state.auth.user);
    const role = user ? user.role : 'undefined';
    const [ isArchive, setIsArchive ] = useState(false);

    // Для агента узнаем есть ли архив
    useEffect(() => {
        const fetchData = async (agent) => {
			const method = '/agent2event';
			const params = { agent };
			const result = await get(method, params);
			if(result.data) {
                const archive = result.data.agent2event.filter(d => d.event.is_archived === true);
                setIsArchive(archive.length > 0);
			} else {
				setIsArchive(false);
            }
		};
        if(user?.role === 'agent') fetchData(user._id);
    }, [ user ]);

    // Для экспонента узнаем есть ли архив
    useEffect(() => {
        const fetchData = async (exhibitor) => {
			const method = '/eventsbyexhibitor';
			const params = { exhibitor, archived: true };
			const result = await get(method, params);
			if(result.data) {
                setIsArchive(result.data.events.length > 0);
			} else {
				setIsArchive(false);
            }
		};
        if(user?.role === 'exhibitor') fetchData(user._id);
    }, [ user ]);


	return (
        <div className='SidebarMenu'>

            {(role === 'undefined') &&
            <React.Fragment>
                <SidebarLink
                    to='/cabinet/login'
                    cmp='/cabinet/login'
                    icon={faDoorOpen}
                    text={t('menu.login')}
                />
                <SidebarLink
                    to='/cabinet/restore'
                    cmp='/cabinet/restore'
                    icon={faCircleQuestion}
                    text={t('menu.restore')}
                />
                <SidebarLink
                    to='/cabinet/newpass'
                    cmp='/cabinet/newpass'
                    icon={faPenToSquare}
                    text={t('menu.newpass')}
                />
            </React.Fragment>}

            {(role === 'exhibitor' || role === 'agent') &&
            <React.Fragment>
                <SidebarLink
                    to='/cabinet/active'
                    cmp='/cabinet/active'
                    icon={faHouse}
                    text={t('menu.home')}
                />
                {isArchive && <SidebarLink
                    to='/cabinet/archive'
                    cmp='/cabinet/archive'
                    icon={faBoxArchive}
                    text={t('menu.archive')}
                />}
            </React.Fragment>}

            {(role === 'root' || role === 'admin') &&
            <React.Fragment>
                <SidebarLink
                    to='/cabinet/userlist'
                    cmp='/cabinet/user'
                    icon={faUserGroup}
                    text={t('menu.userlist')}
                />
                <SidebarLink
                    to='/cabinet/eventlist'
                    cmp='/cabinet/event'
                    icon={faList}
                    text={t('menu.eventlist')}
                />
                <SidebarLink
                    to='/cabinet/exhibitorlist'
                    cmp='/cabinet/exhibitor'
                    icon={faCity}
                    text={t('menu.exhibitorlist')}
                />
                <SidebarLink
                    to='/cabinet/countrylist'
                    cmp='/cabinet/country'
                    icon={faGlobe}
                    text={t('menu.countrylist')}
                />
            </React.Fragment>}

        </div>
	);
};

export default SidebarMenu;
